import uniq from 'lodash.uniq';
import buildInheritedFilters from './build-inherited-filters';
const getUpdatedFilterBy = (inheritedFilters, entityData, currentSchema, filterEntitySchema, itemId, props) => {
  if (inheritedFilters && inheritedFilters.length) {
    const relationFilters = buildInheritedFilters(entityData, inheritedFilters, currentSchema, filterEntitySchema, itemId);
    return relationFilters.length ? uniq([...props.filterBy, ...relationFilters]) : null;
  }
  return [];
};
export default getUpdatedFilterBy;
//# sourceMappingURL=get-updated-filter-by.js.map